import { ElementType, ReactElement } from 'react'

import styles from './Title.module.scss'

export type TitleProps = {
	level?: `${TitleLevels}`
	bottomOffset?: `0` | `0.5x` | `1x` | `2x` | `3x` | `4x` | `5x` | `6x`
	as?: ElementType | keyof JSX.IntrinsicElements | never
	children?: string | ReactElement
}

export enum TitleLevels {
	H1 = 1,
	H2 = 2,
	H3 = 3,
	H4 = 4,
	H5 = 5
}

/**
 * HTML heading - h1–h5
 *
 *
 * @param props
 * @param props.level - Set content importance. Match with h1, h2, h3, h4, h5
 * @param props.as - If you need for example an h1 header that looks like h2 – <Title level="2" as="h1">
 * @param props.bottomOffset - bottom offset multiplier, x=8px
 * @param props.children - Inner content;
 */
export const Title = ({ children, as, level = `${TitleLevels.H1}`, bottomOffset }: TitleProps): JSX.Element => {
	const Level = (as || `h${level}`) as any
	const className = `${styles.title} ${styles[`h${level}`]}`
	return (
		<Level
			className={className}
			style={{ marginBottom: bottomOffset ? `${8 * parseFloat(bottomOffset)}px` : undefined }}>
			{children}
		</Level>
	)
}
